import { Bar, mixins } from 'vue-chartjs'
import waterFallPlugin from 'chartjs-plugin-waterfall'

export default {
  extends: Bar,
  mixins: [mixins.reactiveProp],
  props: ['chartData', 'options', 'cssClasses', 'height', 'width', 'styles'],
  mounted () {
    this.addPlugin(waterFallPlugin)
    this.renderChart(this.chartData, this.options)
  }
}



// WEBPACK FOOTER //
// ./src/components/views/waterfallchart.js